(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["native-availability-calendar"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.native-availability-calendar').forEach((calendar) => {
  const search = calendar.querySelector('[data-native-availability-search]');
  const availableOnly = calendar.querySelector('[data-native-availability-only]');
  const rows = Array.from(calendar.querySelectorAll('[data-native-availability-row]'));
  const applyFilters = () => {
    const query = (search?.value || '').trim().toLowerCase();
    rows.forEach((row) => {
      const matchesSearch = !query || (row.dataset.productTitle || '').includes(query);
      const hasAvailable = Array.from(row.querySelectorAll('td[data-available]')).some((cell) => cell.dataset.available === 'true');
      const matchesAvailability = !availableOnly?.checked || hasAvailable;
      row.hidden = !(matchesSearch && matchesAvailability);
    });
  };
  search?.addEventListener('input', applyFilters);
  availableOnly?.addEventListener('change', applyFilters);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-addon-popup"] && !Shopify.designMode) return;
  try {
    

(() => {

  const initAddonPopup = (root) => {

    if (
      !root ||
      root.dataset.addonPopupInitialized === 'true'
    ) {
      return;
    }

    root.dataset.addonPopupInitialized =
      'true';

    const dialog =
      root.querySelector(
        '[data-addon-dialog]'
      );

    const variantInput =
      root.querySelector(
        '[data-addon-variant]'
      );

    const acceptButton =
      root.querySelector(
        '[data-addon-accept]'
      );

    const declineButtons =
      root.querySelectorAll(
        '[data-addon-decline]'
      );

    const errorBox =
      root.querySelector(
        '[data-addon-error]'
      );

    const variantsScript =
      root.querySelector(
        '[data-main-variant-ids]'
      );

    if (
      !dialog ||
      !variantInput ||
      !acceptButton ||
      !variantsScript
    ) {
      return;
    }

    let mainVariantIds = [];

    try {

      mainVariantIds =
        JSON.parse(
          variantsScript.textContent
        ).map(String);

    } catch (error) {

      return;

    }

    const mainVariantSet =
      new Set(
        mainVariantIds
      );

    let pendingForm = null;

    let busy = false;


    const setBusy = (state) => {

      busy = state;

      acceptButton.disabled =
        state;

      declineButtons.forEach(
        (button) => {

          button.disabled =
            state;

        }
      );

    };


    const showError = (message) => {

      if (!errorBox) {
        return;
      }

      errorBox.textContent =
        message;

      errorBox.hidden =
        false;

    };


    const clearError = () => {

      if (!errorBox) {
        return;
      }

      errorBox.textContent =
        '';

      errorBox.hidden =
        true;

    };


    const getCartElement = () => {

      const candidates = [

        document.querySelector(
          'cart-drawer'
        ),

        document.querySelector(
          'cart-notification'
        ),

        document.querySelector(
          'cart-items'
        )

      ];

      return candidates.find(
        (element) =>
          element &&
          typeof element.getSectionsToRender ===
          'function'
      ) || null;

    };


    const getSections = (
      cartElement
    ) => {

      if (!cartElement) {

        return [
          'cart-drawer',
          'cart-icon-bubble'
        ];

      }

      try {

        const sections =
          cartElement
            .getSectionsToRender()
            .map(
              (section) =>
                section.section ||
                section.id
            )
            .filter(Boolean);

        return [
          ...new Set(sections)
        ].slice(0, 5);

      } catch (error) {

        return [
          'cart-drawer',
          'cart-icon-bubble'
        ];

      }

    };


    const buildMainItem = (
      form
    ) => {

      const formData =
        new FormData(form);

      const id =
        Number(
          formData.get('id')
        );

      const quantity =
        Math.max(
          1,
          Number(
            formData.get(
              'quantity'
            )
          ) || 1
        );

      if (!id) {

        throw new Error(
          'A product variant could not be selected.'
        );

      }

      const item = {
        id,
        quantity
      };

      const properties = {};


      for (
        const [key, value]
        of formData.entries()
      ) {

        const match =
          key.match(
            /^properties\[(.+)\]$/
          );

        if (!match) {
          continue;
        }

        if (
          value instanceof File
        ) {

          if (value.size > 0) {

            throw new Error(
              'This product uses a file-upload option that cannot be submitted through the add-on popup.'
            );

          }

          continue;

        }

        if (
          String(value).length >
          0
        ) {

          properties[
            match[1]
          ] =
            String(value);

        }

      }


      if (
        Object.keys(
          properties
        ).length > 0
      ) {

        item.properties =
          properties;

      }


      const sellingPlan =
        formData.get(
          'selling_plan'
        );

      if (sellingPlan) {

        item.selling_plan =
          Number(
            sellingPlan
          );

      }

      return item;

    };


    const refreshFallbackSections =
      (sections) => {

        if (!sections) {
          return false;
        }

        let refreshed = false;

        Object.entries(
          sections
        ).forEach(
          ([sectionId, html]) => {

            if (!html) {
              return;
            }

            const current =
              document.getElementById(
                `shopify-section-${sectionId}`
              );

            if (!current) {
              return;
            }

            const parsed =
              new DOMParser()
                .parseFromString(
                  html,
                  'text/html'
                );

            const replacement =
              parsed.getElementById(
                `shopify-section-${sectionId}`
              );

            if (replacement) {

              current.replaceWith(
                replacement
              );

              refreshed = true;

            }

          }
        );

        return refreshed;

      };


    const openCart = () => {

      const drawer =
        document.querySelector(
          'cart-drawer-component, cart-drawer, cart-notification'
        );

      if (
        drawer &&
        typeof drawer.open ===
        'function'
      ) {

        drawer.open();

        return true;

      }

      return false;

    };


    const addItems = async (
      includeAddon
    ) => {

      if (
        !pendingForm ||
        busy
      ) {
        return;
      }

      clearError();

      setBusy(true);


      try {

        const mainItem =
          buildMainItem(
            pendingForm
          );

        const items = [
          mainItem
        ];


        if (includeAddon) {

          const addonVariantId =
            Number(
              variantInput.value
            );

          if (!addonVariantId) {

            throw new Error(
              'The add-on variant is unavailable.'
            );

          }

          const fixedAddonQuantity =
            Math.max(
              1,
              Number(
                root.dataset
                  .addonQuantity
              ) || 1
            );

          const matchMainQuantity =
            root.dataset
              .matchMainQuantity ===
            'true';

          items.push({

            id:
              addonVariantId,

            quantity:
              matchMainQuantity
                ? mainItem.quantity
                : fixedAddonQuantity

          });

        }


        const cartElement =
          getCartElement();

        const sections =
          getSections(
            cartElement
          );


        const routeRoot =
          window.Shopify &&
          window.Shopify.routes &&
          window.Shopify.routes.root

            ? window.Shopify
                .routes
                .root

            : '/';


        const response =
          await fetch(
            `${routeRoot}cart/add.js`,
            {

              method: 'POST',

              headers: {

                'Content-Type':
                  'application/json',

                'Accept':
                  'application/json'

              },

              body:
                JSON.stringify({

                  items,

                  sections,

                  sections_url:
                    window.location
                      .pathname

                })

            }
          );


        const data =
          await response.json();


        if (!response.ok) {

          throw new Error(

            data.description ||
            data.message ||
            'The item could not be added to the cart.'

          );

        }


        dialog.close();


        let cartHandled =
          false;


        if (
          cartElement &&
          typeof
            cartElement
              .renderContents ===
          'function'
        ) {

          cartElement
            .renderContents(
              data
            );

          cartHandled =
            true;

        } else {

          cartHandled =
            refreshFallbackSections(
              data.sections
            );

          if (cartHandled) {

            openCart();

          }

        }


        document.dispatchEvent(

          new CustomEvent(
            'cart:update',
            {

              bubbles: true,

              detail: {

                source:
                  'product-addon-popup',

                cartData:
                  data

              }

            }
          )

        );


        if (
          !cartHandled &&
          !openCart()
        ) {

          window.location.href =
            `${routeRoot}cart`;

        }


        pendingForm =
          null;

      } catch (error) {

        showError(

          error.message ||
          'Something went wrong while adding the item.'

        );

      } finally {

        setBusy(false);

      }

    };


    const handleSubmit = (
      event
    ) => {

      const form =
        event.target;


      if (
        !(form instanceof
          HTMLFormElement)
      ) {
        return;
      }


      if (
        !form.matches(
          'form[action*="/cart/add"]'
        )
      ) {
        return;
      }


      if (busy) {
        return;
      }


      const formData =
        new FormData(form);


      const variantId =
        String(
          formData.get('id') ||
          ''
        );


      if (
        !mainVariantSet.has(
          variantId
        )
      ) {
        return;
      }


      if (
        event.submitter &&
        event.submitter.name &&
        event.submitter.name !==
          'add'
      ) {
        return;
      }


      event.preventDefault();

      event.stopImmediatePropagation();


      pendingForm =
        form;

      clearError();


      if (
        typeof dialog.showModal ===
        'function'
      ) {

        dialog.showModal();

      } else {

        addItems(false);

      }

    };


    document.addEventListener(
      'submit',
      handleSubmit,
      true
    );


    acceptButton.addEventListener(
      'click',
      () =>
        addItems(true)
    );


    declineButtons.forEach(
      (button) => {

        button.addEventListener(
          'click',
          () =>
            addItems(false)
        );

      }
    );


    dialog.addEventListener(
      'cancel',
      (event) => {

        event.preventDefault();

        addItems(false);

      }
    );


    dialog.addEventListener(
      'click',
      (event) => {

        if (
          event.target !==
            dialog ||
          busy
        ) {
          return;
        }


        const rect =
          dialog
            .getBoundingClientRect();


        const inside =

          event.clientX >=
            rect.left &&

          event.clientX <=
            rect.right &&

          event.clientY >=
            rect.top &&

          event.clientY <=
            rect.bottom;


        if (!inside) {

          addItems(false);

        }

      }
    );

  };


  const initAll = (
    scope = document
  ) => {

    scope
      .querySelectorAll(
        '[data-product-addon-popup]'
      )
      .forEach(
        initAddonPopup
      );

  };


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      () =>
        initAll()
    );

  } else {

    initAll();

  }


  document.addEventListener(
    'shopify:section:load',
    (event) =>
      initAll(
        event.target
      )
  );

})();


  } catch(e) { console.error(e); }
})();
})();
